import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { LoginRoutingModule } from './login.routing';
import { LoginComponent } from './login.component';
import { AlertModule } from '@michelin/theme';

@NgModule({
  imports: [SharedModule, LoginRoutingModule, AlertModule],
  providers: [],
  declarations: [LoginComponent]
})
export class LoginModule {}
